import { reduce } from 'lodash/fp';
import { SCALE } from '@ahmdigital/constants';

import { DataByProductType } from '../../types';
import { ProductList } from '../../../../../../types/__codegen__/sanity/graphql';

const transformProductListsToOptions = (productLists: ProductList[]) => {
  const scaleProductListKeys = {
    [SCALE.COUPLE]: 'productIdsCouple',
    [SCALE.FAMILY]: 'productIdsFamily',
    [SCALE.SINGLE]: 'productIdsSingle',
    [SCALE.SINGLE_PARENT]: 'productIdsSingleParent',
  };

  return reduce(
    (dataByProductType, { productType, urlObject, ...sanityProductListData }) => {
      const productIdsByScale = Object.entries(scaleProductListKeys)
        .filter(([, sanityProductListKey]) =>
          Array.isArray((sanityProductListData as Record<string, any>)[sanityProductListKey]),
        )
        .map(([scale, sanityProductListKey]) => [
          scale,
          (sanityProductListData as Record<string, any>)[sanityProductListKey],
        ]);

      return {
        ...dataByProductType,
        [productType as string]: {
          ctaLink: urlObject?.url ?? null,
          ctaText: urlObject?.name ?? null,
          ...Object.fromEntries(productIdsByScale),
        },
      };
    },
    {} as DataByProductType,
    productLists,
  );
};

export default transformProductListsToOptions;
